function PlayIcon({ className, width = '3.2rem', height = '3.2rem', color = 'currentColor', regular = false }) {
    return (
        regular ?
            <svg className={className} width={width} height={height} viewBox="0 0 48 48" fill={color} xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M16 10.554V37.4459L38.1463 24L16 10.554ZM12 8.77702C12 6.43812 14.5577
                4.99881 16.5569 6.21266L41.6301 21.4356C43.5542 22.6038 43.5542 25.3962 41.6301 26.5644L16.5569 41.7873C14.5577
                43.0012 12 41.5619 12 39.223V8.77702Z">
                </path>
            </svg>
            :
            <svg xmlns="http://www.w3.org/2000/svg" className={className} width={width} height={height} viewBox="0 0 24 24">
                <path fill={color} d="M8 5v14l11-7z" />
            </svg>
    );
}

export default PlayIcon;